import { render, staticRenderFns } from "./Report-Detail.vue?vue&type=template&id=784e0b5e&"
import script from "./Report-Detail.vue?vue&type=script&lang=js&"
export * from "./Report-Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports